import * as React from 'react';
const SvgMed = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M46.032 62V42.645L36.84 54.742l-8.71-12.097V62M67.806 42.645H58.13V62h9.677M58.129 52.322h7.742M78.936 42.645V62s13.548 2.903 13.548-9.677c0-12.581-13.548-9.678-13.548-9.678ZM79.884 75.955l9.15 41.584 9.261-11.947L113.798 122l8.202-7.752-15.498-16.408 12.396-6.692-39.014-15.193Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.742 98.774H5.87A3.87 3.87 0 0 1 2 94.904V5.87A3.87 3.87 0 0 1 5.871 2h112.258A3.87 3.87 0 0 1 122 5.871v73.548M2 21.355h120"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.678 11.678h3.87M21.355 11.678h3.87M31.032 11.678h3.871"
      stroke="#000"
      strokeWidth={4}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgMed;
